export default __webpack_public_path__ + "0f49d118f165a55fcbac60bdedc4624c.svg";